import { useEffect, useState } from 'react'
import { Teeth } from '../../../Assets/SVGS'
import Header from '../../common/Header/Header'
import PlansCard from './PlansCard/PlansCard'
import './PlansSection.css'
import getData from '../../../utils/getData'
import { useTranslation } from 'react-i18next'
function PlansSection(){
  const { t } = useTranslation();
  const [types , setTypes] = useState([])

  const getMyTypes = async()=>{
    const res = await getData('appointment-type')
    setTypes(res?.data?.data)
  }

  useEffect(()=>{
    getMyTypes()
  },[])
  return(
    <div className="plansSection-container container">
      
      <Header header={t('bestTreatment')} desc={t('bestTreatmentDesc')}/>

      <div className="plansSection-content content">
        {
          types?.map((item)=>(
            <PlansCard icon={<Teeth width="50px"/>} header={item.type} price={item.price} list={[
            "Routine Dental Checkup & Cleaning",
            "Basic Diagnostic X-Rays",
            "Plaque & Tartar Removal",
            "Personalized Treatment Plan",
            "Free Follow-up Visit within 14 Days"
          ]} link="booking"/>
            )
          )
        }
      </div>
    </div>
  )
}
export default PlansSection